module.exports = __webpack_public_path__ + "img/economic-growth.f0f0c30a.png";